function initialState() {
  return {
    stageTypes: [],
    stageStatuses: [],
    dealerOrchestrationsByPlatformId: {},
    dealerOrchestrationById: {}
  };
}

function getResponseData(response) {
  if (!response || !response.data) return null;
  return typeof response.data.data !== "undefined"
    ? response.data.data
    : response.data.Data;
}

function getResponseMessage(response) {
  if (!response || !response.data) return null;
  return response.data.message || response.data.Message || null;
}

function createRequestError(response, fallbackMessage) {
  const error = new Error(getResponseMessage(response) || fallbackMessage);
  error.response = response;
  error.data = getResponseData(response);
  return error;
}

const actions = {
  async fetchOrchestrationStageTypes(context) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      "/api/orchestration/stageTypes"
    ).catch(err => err.response);

    const data = getResponseData(response) || [];
    context.commit("setOrchestrationStageTypes", data);
    return data;
  },
  async fetchOrchestrationStageStatuses(context) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      "/api/orchestration/stageStatuses"
    ).catch(err => err.response);

    const data = getResponseData(response) || [];
    context.commit("setOrchestrationStageStatuses", data);
    return data;
  },
  async fetchDealerOrchestrations(context, accountPlatformId) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      `/api/orchestration/platformId/${accountPlatformId}`
    ).catch(err => err.response);

    const data = getResponseData(response) || [];
    context.commit("setDealerOrchestrations", {
      accountPlatformId,
      orchestrations: data
    });
    return data;
  },
  async fetchDealerOrchestration(context, dealerOrchestrationId) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      `/api/orchestration/${dealerOrchestrationId}`
    ).catch(err => err.response);

    const data = getResponseData(response);
    if (data) {
      context.commit("setDealerOrchestration", data);
    }
    return data;
  },
  async validateDealerOrchestration(context, dealerOrchestration) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/orchestration/validateDealerOrchestration",
      dealerOrchestration
    ).catch(err => err.response);

    if (!response || response.status >= 400) {
      throw createRequestError(
        response,
        "Unable to validate the orchestration."
      );
    }

    return getResponseData(response) || [];
  },
  async saveDealerOrchestration(context, dealerOrchestration) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/orchestration",
      dealerOrchestration
    ).catch(err => err.response);

    if (!response || response.status >= 400) {
      throw createRequestError(response, "Unable to save the orchestration.");
    }

    const data = getResponseData(response);

    if (data) {
      context.commit("setDealerOrchestration", data);
      context.commit("upsertDealerOrchestrationForPlatform", data);
    }

    return data;
  },
  async approveDealerOrchestrationStage(context, dealerOrchestrationStageId) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      `/api/orchestration/approveStage/${dealerOrchestrationStageId}`
    ).catch(err => err.response);

    if (!response || response.status >= 400) {
      throw createRequestError(response, "Unable to approve the request.");
    }

    return getResponseData(response);
  },
  async denyDealerOrchestrationStage(context, payload) {
    const requestPayload = {
      dealerOrchestrationStageId:
        payload && payload.dealerOrchestrationStageId
          ? payload.dealerOrchestrationStageId
          : 0,
      denyReason: (payload && payload.denyReason) || ""
    };

    const response = await context.getters.CxmApiClient.ProcessRequest(
      "POST",
      "/api/orchestration/denyStage",
      requestPayload
    ).catch(err => err.response);

    if (!response || response.status >= 400) {
      throw createRequestError(response, "Unable to deny the request.");
    }

    return getResponseData(response);
  }
};

const mutations = {
  setOrchestrationStageTypes(state, data) {
    state.stageTypes = Array.isArray(data) ? data : [];
  },
  setOrchestrationStageStatuses(state, data) {
    state.stageStatuses = Array.isArray(data) ? data : [];
  },
  setDealerOrchestrations(state, payload) {
    if (!payload || !payload.accountPlatformId) return;

    state.dealerOrchestrationsByPlatformId = {
      ...state.dealerOrchestrationsByPlatformId,
      [payload.accountPlatformId]: Array.isArray(payload.orchestrations)
        ? payload.orchestrations
        : []
    };
  },
  setDealerOrchestration(state, orchestration) {
    if (!orchestration || !orchestration.id) return;

    state.dealerOrchestrationById = {
      ...state.dealerOrchestrationById,
      [orchestration.id]: orchestration
    };
  },
  upsertDealerOrchestrationForPlatform(state, orchestration) {
    if (!orchestration || !orchestration.accountPlatformId) return;

    const existing =
      state.dealerOrchestrationsByPlatformId[orchestration.accountPlatformId] ||
      [];
    const next = existing.filter(item => item.id !== orchestration.id);
    next.push(orchestration);
    next.sort((left, right) => {
      const leftDate = left && left.startDt ? new Date(left.startDt).getTime() : 0;
      const rightDate =
        right && right.startDt ? new Date(right.startDt).getTime() : 0;

      return leftDate - rightDate;
    });

    state.dealerOrchestrationsByPlatformId = {
      ...state.dealerOrchestrationsByPlatformId,
      [orchestration.accountPlatformId]: next
    };
  }
};

const getters = {
  OrchestrationStageTypes(state) {
    return state.stageTypes || [];
  },
  OrchestrationStageStatuses(state) {
    return state.stageStatuses || [];
  },
  DealerOrchestrationsByPlatformId: state => accountPlatformId => {
    return state.dealerOrchestrationsByPlatformId[accountPlatformId] || [];
  },
  DealerOrchestrationById: state => dealerOrchestrationId => {
    return state.dealerOrchestrationById[dealerOrchestrationId] || null;
  }
};

export default {
  state: initialState(),
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/orchestration.js